import { h } from "preact";
import LFeed from "../../../services/live-feed";

// Praticamente identico a come lo ha lasciato klodi. Non mi sto sprecando a capirlo per ora

export const DefaultWidgetNonSeamless = ({ event }) => {
	const sport = LFeed.menu[event.sport]
	return <div>
		<div class="game-statistic-view info">
			<table>
				<tbody>
					<tr>
						<td />
						{(event.result || []).map(({ phase }) => (
							<td key={"gsn" + phase}>{phase}</td>
						))}

						{event.sport === '/sport/4' ? <td>Points</td> : <td>Set</td>}
						<td>&nbsp;</td>
					</tr>
					<tr>
						<td>
							<p class="name-wrapper-s">
								<b class="team-name-statistic">{event.teams.home.name}</b>
							</p>
						</td>
						{(event.result || []).map(({ phase, result }) => (
							<td key={"gst1" + phase}>{(result || "").split("-")[0]}</td>
						))}
						<td>{event.current["result"][0]}</td>
						{event.sport === '/sport/5' ? <td>{event.current.result[0] || 0}</td> : null}
						<td class={"pass" + (event.current.info[0] == "S" ? " active" : "")}>
							<b class={"mini-icon " + sport.label} />
						</td>
					</tr>
					<tr>
						<td>
							<p class="name-wrapper-s">
								<b class="team-name-statistic">{event.teams.away.name}</b>
							</p>
						</td>
						{(event.result || []).map(({ phase, result }) => (
							<td key={"gst1" + phase}>{result.split("-")[1]}</td>
						))}
						<td>{event.current["result"][1]}</td>
						{event.sport === '/sport/5' ? <td>{event.current.result[1] || 0}</td> : null}
						<td class={"pass" + (event.current.info[1] == "S" ? " active" : "")}>
							<b class={"mini-icon " + sport.label} />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>;
};

export const TeamsNames = ({ event }) => (
	<div>
		<div class="game-score-view">
			<ul>
				<li class="team-name-statistic-view">
					<p>
						<b>
							<img
								src={
									event.teams && event.teams.home.uid
										? `https://ls.sportradar.com/ls/crest/medium/${event.teams.home.uid}.png`
										: logoUrl(event.teams.home.id)
								}
							/>
						</b>
						<span class="team-name-score-v">
							<i>{event.teams.home.name}</i>
						</span>
					</p>
				</li>
				<li class="draw-column-view">
					<p>
						{event.current.result.split("-")[0]} &nbsp;:&nbsp; {event.current.result.split("-")[1]}
					</p>
				</li>
				<li class="team-name-statistic-view">
					<p>
						<span class="team-name-score-v">
							<i>{event.teams.away.name}</i>
						</span>
						<b>
							<img
								src={
									event.teams && event.teams.away.uid
										? `https://ls.sportradar.com/ls/crest/medium/${event.teams.away.uid}.png`
										: logoUrl(event.teams.away.id)
								}
							/>
						</b>
					</p>
				</li>
			</ul>
		</div>
	</div>
);

export const SoccerTimeline = ({ event }) => {
	return (
		event.sport == '/sport/1' &&
		event.misc.timeline && (
			<div>
				<div className="time-phase">
					<span>
						{" "}
						<i class="clock-timerrrr"></i> {event.misc.tracker.timer}
					</span>
					<span>{event.status.phase}</span>
				</div>
				<div class="timeline-container">
					<div
						class={
							"timeline-control" + (event.misc.timeline.length === "80" ? " tl-80" : "") + (isExtraTime(event.info) ? " extra" : "")
						}
					>
						<span class="tl-15" />
						<span class="tl-30" />
						<span class="tl-45" />
						<span class="tl-60" />
						<span class="tl-75" />
						<span class="tl-90" />
						<span class="tl-20" />
						<span class="tl-40" />
						<span class="tl-6-0" />
						<span class="tl-80" />
						<span class="ht-ft" />
					</div>
					<div class="tl-data">
						<div class="current-minute" style={{ width: getminuteProportion(event.misc) }} />
						{parseTimeline(event.misc, event).map((ev, index) => (
							<div
								key={index}
								style={{
									position: "absolute",
									left: ev.timeline_position + "%",
								}}
								class={ev.team + "-" + ev.type}
							>
								<div class={ev.type}></div>
								<div class={"tl-details" + (ev.minute > 50 ? " to-right" : "")}>
									{ev.details.type} {ev.details.add_info}
								</div>
							</div>
						))}
						<div class="tl-info" style={{ left: getminuteProportion(event.misc) }} />
					</div>
				</div>
			</div>
		)
	);
};

const parseTimeline = (misc, event) =>
	misc.timeline.data
		.filter((ev) => !!ev.name)
		.map((ev) => ({
			minute: parseInt(ev.timer),
			type: "tl-" + ev.name.toLowerCase(),
			shirt: ev.team == "home" ? misc.info.shirt1_color : misc.info.shirt2_color,
			team: ev.team == "home" ? "team1" : "team2",
			timeline_position: eventProportion(parseInt(ev.timer), parseInt(ev.length) || 90),
			details: {
				type: ev.name,
				add_info: `${ev.timer} ${event.teams[ev.team].name}`,
			},
		}));

const eventProportion = (minute, length) => (minute / length) * 100;

const getminuteProportion = (misc) => {
	const currentMinute = Math.max(
		0,
		parseInt(misc.info.current_game_time) || (misc.info.current_game_state == "Half Time" && misc.timeline.length / 2),
	);

	return isExtraTime(misc.info)
		? Math.min((100 * (currentMinute - 90)) / 30, 100) + "%"
		: misc.timeline && misc.timeline.length == "80"
		? Math.min(100, (currentMinute * 100) / 80) + "%"
		: Math.min(100, (currentMinute * 100) / 90) + "%";
};

const isExtraTime = (info) =>
	info &&
	(info.current_game_state === "additional_time1" ||
		info.current_game_state === "additional_time2" ||
		info.current_game_state === "set3" ||
		info.current_game_state === "set4" ||
		(info.current_game_state === "timeout" && info.currMinute > 100));
